import { Snackbar } from '@mui/material';
import { Alert } from '@mui/material';
import { Modal } from "antd";
import { DeleteModal } from "components/Dialog";
import { useFirebase } from "containers/FirebaseContext";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  runTransaction,
  setDoc,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { filter, get, map , debounce } from "lodash";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useBingoModal } from "store/OneWayBingo/selectors";
import {
  handleCreateOneWayBingo,
  handleLearningModuleCount,
  handleSyncBingo,
  handleUpdateOneWayBingo,
} from "store/bingo/thunks";
import { useCurrentClass } from "store/classes/selectors";
import { useClassGameActivity } from "store/one_game/selectors";
import { handleListClassSubmissions } from "store/submissions/thunks";
import { useClassUsers } from "store/userClasses/selectors";
import { useCurrentUser } from "store/users/selectors";
import { useVocabulary } from "store/vocabulary/selectors";
import styled from "styled-components";
import "swiper/css";
import "swiper/css/bundle";
import { COLORS } from "utils/config/reference";
import LoteriaGameIcon from "../../utils/assets/images/LoteriaGameIcon.svg";
import { useCollectionLoteria } from "utils/methods/firebaseBingo";
import { v4 } from "uuid";
import BingoCreateSection from "./BingoCreateSection";
import BingoGridSection from "./BingoGridSection";
import BingoStudentDetail from "./BingoStudentDetail";
import BingoStudentsResult from "./BingoStudentsResult";
import BingoStudentContent from "./StudentBingo/BingoStudentContent";
import { createGridTeacher } from "./helper";
import OneBingoModal from "./OneBingoModal";
import useWindowActive from "utils/methods/checkWindowActive";
import { handleListClassUsers } from "store/userClasses/thunks";
import SentryWrap from "components/Sentry";
import GradeModal from "./GradeModal";
import StudentConfirm from "./StudentBingo/StudentConfirm";
import { generateRandomLightColor } from "utils/methods/math";
import useDisableAutoZoomWithModal from "components/hooks/useDisableAutoZoom";
import * as Sentry from '@sentry/react';
import { handleListOneGameGallery } from 'store/1GameGallery/thunks';
import { handleListOneGameCategory } from 'store/1GameCategory/thunks';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { useHowlAudio } from 'components/hooks/useHowlProvider';
import { Badge } from '@mui/material';
import { useBingoThemeSongs } from './playThemeSong/useBingoThemeSongs';

const DebateModalWrapper = styled.div`
  max-height: 90px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background: transparent;
  z-index: 11;
  -webkit-transition: all 1s ease 0s;
  transition: all 1s ease 0s;
  cursor: pointer;
}
`;

const BingoModal = ({
  bingoModals,
  setBingoModals,
  debatesModal,
  setDebatesModal,
  chapter,
  page,
  type = "",
  newMaskId = "",
  from_where='',
  showIcon = true,
  from='deafult',
  pageLearningModuleCount
}) => {
  const dispatch = useDispatch();
  const isWindowActive = useWindowActive();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const classUsers = useClassUsers();
  const classStudentUsers = classUsers?.filter(
    (obj) => obj?.role === "student"
  );

  const [playConfigModal, setPlayConfigModal] = useState(false);
  const [selectedGame, setSelectedGame] = useState({});


  const { updateLoteriaResult, updateTeacherWinner, updateRealTimeClick } = useCollectionLoteria();
  const [bingoModal, invokeBingoModal, revokeBingoModal] = useBingoModal();

  const [openListModal, setOpenListModal] = useState(false);

  const [previousDebateId, setPreviousDebateId] = useState(null);
  const [allContentType, setAllContentType] = useState(false);
  const [openTeacherModal, setOpenTeacherModal] = useState("");

  const [studentEditClick, setStudentEditClick] = useState(true);
  const [studentContentType, setStudentContentType] = useState(false);
  const [indexs, setIndex] = useState(0);

  const [blogContentType, setBlogContentType] = useState(true);

  const [studentCommentSec, setStudentCommentSec] = useState(true);
  const [closeStudentModal, setCloseStudentModal] = useState(false);

  const [bingoGrid, setBingoGrid] = useState(false);
  const [grid, setGrid] = useState(createGridTeacher(3));
  const [selectedBingoType, setSelectedBingoType] = useState("");
  const [bingoInstruction, setBingoInstruction] = useState("");
  const [bingoConfig, setBingoConfig] = useState({});
  const [gridValueSize, setGridValueSize] = useState(0);
  const [playThemeSongFirstTime, setPlayThemeSongFirstTime] = useState(false);
  const [selectedThemeSongIndex, setSelectedThemeSongIndex] = useState(0);

  const [lastSavedBingoData, setLastSavedBingoData] = useState(null);
  const { createDraftBingo } = useCollectionLoteria();

  // Auto-save bingo grid data after 4-5 seconds of inactivity
  const saveGridTimeoutRef = useRef(null);

  const [resultLoader, setResultLoader] = useState(false);

  const [bingoEndScreen, setBingoEndScreen] = useState(false);

  const [shareLoader, setShareLoader] = useState(false);

  const [debateResponse, setDebateResponse] = useState({});

  const [studentSubmission, setStudentSubmission] = useState([]);
  const [myStudentSubmission, setMyStudentSubmission] = useState([]);
  const [submittedSubmission, setSubmittedSubmission] = useState([]);;

  const [submitLoader, setSubmitLoader] = useState(false);
  const [editLoteria, setEditLoteria] = useState({});
  const [endLoader, setEndLoader] = useState(false);
  const resetChildStates = useRef(null);
  useDisableAutoZoomWithModal();

  // Grade State
  const [gradeEnable, setGardeEnable] = useState(false);
  const [game_grade_category, setGameGradeCategory] = useState({});
  const [game_grade_type, setGameGradeType] = useState({});
  const [game_ungraded, setGameUngraded] = useState(false);

  // Draft state
  const [draftId, setDraftId] = useState(null);
  const isDeletingRef = useRef(false);

  const [actionForCreate, setActionForCreate] = useState({
    type: "",
    loader: false,
  });
  const [winnerStatus,setWinnerStatus] = useState({
    has_result:false,
    is_me_as_winner:false,
  })

  // Use useRef to track the latest value
  const winnerStatusRef = useRef(winnerStatus);

  // Grade
  const [isGrade, setIsGrade] = useState(false);
  const [gradeConfig, setGradeConfig] = useState({});
  const [showNames, setShowNames] = useState(false);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "info" });
  const { firestore , firebaseUser } = useFirebase();
  const [deleteModal, setDeleteModal] = useState(false);
  const { fetchClassGameActivity } = useClassGameActivity();
  const bookVocabulary = useVocabulary();
  const [getBooksVocab, setGetBooksVocab] = useState([]);
  const [selectedVocabData, setSelectedVocabData] = useState([]);
  const [bingoNotes, setBingoNotes] = useState("");
  const [wheelSpinResult, setWheelSpinResult] = useState([]);
  const [savedGridState, setSavedGridState] = useState(editLoteria?.id ? editLoteria?.bingo_type : []);
  const showSnack = (message, severity = "info") => setSnack({ open: true, message, severity });
  const {checkPopUpAtOnce,updatePopUpAtOnce} = usePopUpAtOnce();
  const {cleanupAllHowl,playHowl,stopHowl, getHowlInstance} = useHowlAudio();
  const { songs: bingoThemeSongs, ready: themeSongsReady } = useBingoThemeSongs();

  const handleForDistrictAdmin = () => {
    if (currentUser.role === 'admin') {
      showSnack('Please login as teacher!', "error");
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (get(currentUser, "role", "") === "owe_admin") {
      if (!draftId) return;
      if (saveGridTimeoutRef.current) {
        clearTimeout(saveGridTimeoutRef.current);
      }
      saveGridTimeoutRef.current = setTimeout(async () => {
        try {
          const processedGridData = fitlerGridData(grid, selectedBingoType);
          // Compare with last saved data (simple JSON string comparison)
          const currentGridString = JSON.stringify(processedGridData);
          const lastGridString = JSON.stringify(lastSavedBingoData);
          if (currentGridString !== lastGridString) {
            await createDraftBingo(draftId, { bingo_data: processedGridData });
            setLastSavedBingoData(processedGridData);
          }
        } catch (error) {
          console.error("Failed to save bingo grid draft:", error);
        }
      }, 2000);
      return () => {
        if (saveGridTimeoutRef.current) {
          clearTimeout(saveGridTimeoutRef.current);
        }
      };
    }
  }, [grid, selectedBingoType, draftId, lastSavedBingoData]);

  useEffect(() => {
    const filterVocab = filter(bookVocabulary, (obj) => obj.page == page);
    const filterByAdmin =
      filterVocab?.filter((data) => data?.created_by === "owe_admin") || [];
    const filterByTeacher =
      filterVocab?.filter((data) => data?.created_by === "teacher") || [];
    const data = [];
    if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
    if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
    const uniqueData = data.filter((item, index, self) => 
      index === self.findIndex((t) => t.id === item.id)
    );
    setGetBooksVocab(uniqueData || []);
  }, [bookVocabulary, chapter, page]);

  const playThemeSong = useMemo(() => {
    return (
      studentEditClick &&
      allContentType &&
      debateResponse &&
      (bingoModal.view || debatesModal)
    );
  }, [
    studentEditClick,
    allContentType,
    debateResponse,
    bingoModal.view,
    debatesModal,
  ]);

  useEffect(() => {
    if (playThemeSong && !playThemeSongFirstTime && themeSongsReady && bingoThemeSongs.length > 0) {
      const randomIndex = Math.floor(Math.random() * bingoThemeSongs.length);
      const randomSong = bingoThemeSongs[randomIndex];
      setSelectedThemeSongIndex(randomIndex);
      const audioConfig = {
        src: [randomSong.url],
        volume: 0.2,
        loop: true,
        html5: true,
        preload: true,
        onError: (error) => {
          console.error("Error playing audio:", error);
        },
        onloaderror: (id, err) => {
          console.error("Audio failed to load:", err);
        },
        onplayerror: (id, err) => {
          console.error("Audio failed to play:", err);
        }
      }
      cleanupAllHowl();
      playHowl(audioConfig, "bingoThemeSong");
      setPlayThemeSongFirstTime(true);
    }
  }, [playThemeSong, playThemeSongFirstTime, themeSongsReady, bingoThemeSongs, cleanupAllHowl, playHowl]);

  const createNewCollection = async (value) => {
    // Create a new collection

    setSubmitLoader(true);
    const user_id = get(currentUser, "id", "");
    const studentAnswer = {
      answer_time: moment().toISOString(),
      user_id: get(currentUser, "id", ""),
      user_name: `${get(currentUser, "firstName", "")} ${get(
        currentUser,
        "lastName",
        ""
      )}`,
      answer_text: JSON.stringify(value),
      bingo_id: debateResponse?.id,
      submission_id: v4(),
      teacher_response: "",
    };

    const updateStudentData = {
      answer_time: moment().toISOString(),
      answer_text: JSON.stringify(value),
      student_status: "submitted",
      teacher_response: "submitted",
    };
    const generated_session_id = user_id + debateResponse?.id;
    const docRef = doc(firestore, "bingo_submission", generated_session_id);
    try {
      // Start the transaction
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, updateStudentData);
        setSubmitLoader(false);
      } else {
        await setDoc(docRef, studentAnswer);
        setSubmitLoader(false);
      }
    } catch (e) {
      Sentry.captureException(`563 Error in createNewCollection: ${e}`);
      console.log("Error adding document: ", e);
    }
  };

  useEffect(() => {
    const unsubscribe = listenToNewDebates(
      currentClass?.id,
      handleChangeDebate,
      openTeacherModal
    );

    return () => {
      unsubscribe();
    };
  }, [firestore, currentClass?.id, previousDebateId, openTeacherModal, isWindowActive]);

  const listenToNewDebates = (classId, onChange, openTeacherModal) => {
    if (!firestore || !classId) {
      return () => {}; // Return an empty function to avoid errors
    }
    const collectionRef = collection(firestore, "bingo");
    const q = query(collectionRef, where("class_id", "==", classId)); // Assuming currentClass is an object containing the ID
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const sessions = [];
        querySnapshot.forEach((doc) => {
          sessions.push({ id: doc.id, ...doc.data() });
        });
        onChange(sessions, openTeacherModal);
      },
      (error) => {
        // console.error('Error listening to new debates:', error);
      }
    );
    return unsubscribe; // Return the unsubscribe function
  };

  const handleChangeDebate = (sessions, openTeacherModal) => {
    const filteredData = sessions?.find((item) => {
      // Compare the dates (ignoring time)
      return item?.status === true;
    });
    if (filteredData) {
      if (filteredData.id !== previousDebateId) {
        setCloseStudentModal(false); // Set closeStudentModal to false when a new debate starts
        setPreviousDebateId(filteredData.id); // Update previousDebateId to the ID of the new debate
        listenToShareData(currentClass?.id);
        if (get(currentUser, "role") !== "student" && !openTeacherModal) {
          if (filteredData?.winner_declared) {
            setBingoEndScreen(true);
            setStudentContentType(true);
            setBlogContentType(false);
          } else {
            setBlogContentType(false);
            setAllContentType(true);
          }
        } else if (get(currentUser, "role") === "student") {
          if (filteredData?.winner_id) {
            const is_me_as_winner = filteredData?.winner_id === currentUser?.id;
            setWinnerStatus({
              has_result: filteredData?.winner_declared,
              is_me_as_winner,
            })
          }
        }
      }
    }
  };

  const onClose = async () => {
    if (setBingoModals) {
      setBingoModals(false);
      handleClose();
    }
    if (get(currentUser, "role") === "student") {
      stopHowl("bingoThemeSong");
      cleanupAllHowl()
      setCloseStudentModal(true);
    }
    if (
      Object.keys(debateResponse).length > 0 &&
      get(currentUser, "role") !== "student"
    ) {
      setDeleteModal(true);
    } else {
      stopHowl("bingoThemeSong");
      cleanupAllHowl();
      updateStatus();
    }
    setDraftId('');
    updatePopUpAtOnce(false);
  };

  const deleteBingoAndSubmission = async (bingoId) => {
    const sessionRef = doc(firestore, "bingo", bingoId);
    const collectionRef = collection(firestore, "bingo_submission");
    const bingoSubQuery = query(collectionRef, where("bingo_id", "==", bingoId));
  
    try {
      await runTransaction(firestore, async (transaction) => {
        // Delete the main bingo document
        const sessionDoc = await transaction.get(sessionRef);
        if (!sessionDoc.exists()) {
          showSnack("Bingo document already deleted, skipping deletion.", "error");
          return;
        }
        transaction.delete(sessionRef);
  
        // Get all related bingo submissions and delete them
        const querySnapshot = await getDocs(bingoSubQuery);
        querySnapshot.forEach((submissionDoc) => {
          transaction.delete(submissionDoc.ref);
        });
      });
    } catch (error) {
      Sentry.captureException(`564 Error in deleteBingoAndSubmission: ${error}`);
      console.error("Transaction failed: ", error);
    }
  };  

  const updateOneWayDebate = async () => {
    try {
      // Reference to the Firestore collection
      const collectionRef = collection(firestore, "bingo_submission");
  
      // Create the query to filter the collection
      const q = query(collectionRef, where("bingo_id", "==", debateResponse?.id));
  
      // Execute the query once
      const querySnapshot = await getDocs(q);
  
      // Collect the documents into an array
      const sessions = [];
      querySnapshot.forEach((doc) => {
        sessions.push({ id: doc.id, ...doc.data() });
      });
  
      // Parse the bingo data
      const parsedBingoData = Array.isArray(debateResponse?.bingo_data)
        ? debateResponse.bingo_data
        : JSON.parse(debateResponse?.bingo_data || "[]");
  
      // Prepare the update data
      const updateData = {
        ...debateResponse,
        status: false,
        answer: JSON.stringify(sessions),
        bingo_data: editLoteria?.id ? grid : parsedBingoData,
      };
  
      const result = await dispatch(handleUpdateOneWayBingo(updateData));
      syncAssignment(updateData);
      await deleteBingoAndSubmission(debateResponse?.id);
      setDebateResponse({});
    } catch (error) {
      Sentry.captureException(`565 Error in updateOneWayDebate: ${error}`);
      console.error("Error fetching data:", error);
    }
  };
  const parseAnswer = (debutInfo) =>{
    try {
      const { answer:answerString } = debutInfo
      if(!answerString) return [];
      else if(typeof answerString === "string"){
        const parsed = JSON.parse(answerString);
        if (!Array.isArray(parsed)) {
          console.error('Parsed answer is not an array:', parsed);
          return [];
        }
        return parsed;
      }else if(typeof answerString === "object"){
        if (!Array.isArray(answerString)) {
          console.error('Answer object is not an array:', answerString);
          return [];
        }
        return answerString;
      } else return [];
    } catch (error) {
      Sentry.captureException(`566 Error in parseAnswer: ${error}`);
      console.log("error... in parsing debutInfo",error.message)
      return []
    }
  }
  async function syncAssignment(debutInfo) {
    const { grade: is_graded, grade_config } = debutInfo.configurations;
    const answer = parseAnswer(debutInfo);
    if (!Array.isArray(answer)) {
      console.error('Answer is not an array:', answer);
      return;
    }
    const filterSubmission = grade_config?.ungraded ? answer: answer;
    if (is_graded) {
      await dispatch(
        handleSyncBingo({
          debut_id: debutInfo.id,
          submissions: Array.isArray(filterSubmission) ? map(filterSubmission, (info) => ({
            answer: info.answer_text,
            user_id: info.user_id,
            user_name: info.user_name,
            bingo_type: debutInfo.bingo_type,
            wheelSpinResult: debutInfo.wheelSpinResult,
            is_submitted: info?.user_grade === true ? true : false
          })) : [],
        })
      );
      Promise.allSettled([
        fetchClassGameActivity(),
        dispatch(handleListClassSubmissions(currentClass.id, false)),
      ]);
    } else {
      console.log("No need to sync grade assignment");
    }
  } 

  const updateStatus = async () => {
    try {
      if (
        Object.keys(debateResponse).length > 0 &&
        get(currentUser, "role") !== "student"
      ) {
        if (isDeletingRef.current) {
          showSnack("Deletion already in progress, skipping...", "error");
          return;
        }
        isDeletingRef.current = true;
        setEndLoader(true);
        await updateOneWayDebate();
        setEndLoader(false);
        setDeleteModal(false);
        setDebateResponse({});
        setShowNames(false);
      }
      closeAllState();
    } catch (error) {
      Sentry.captureException(`567 Error in updateStatus: ${error}`);
      console.log(error);
    } finally {
      isDeletingRef.current = false;
    }
  };

  const closeAllState = () => {
    try {
      setSavedGridState([]);
      setWheelSpinResult([]);
      setGridValueSize(0);
      setSelectedBingoType("");
      setBingoInstruction("");
      setBingoNotes("");
      setGrid([]);
      setBingoGrid(false);
      setAllContentType(false);
      setStudentEditClick(true);
      setStudentContentType(false);
      setBlogContentType(true);
      setStudentCommentSec(true);
      revokeBingoModal();
      setPlayThemeSongFirstTime(false);
      setSelectedVocabData([]);
      stopHowl("bingoThemeSong");
      cleanupAllHowl();
      setEditLoteria({});
      setGardeEnable(false);
      setGameGradeType({});
      setGameUngraded(false);
      setGameGradeCategory({});
      setPlayConfigModal(false);
      setSelectedGame({});
      if (resetChildStates.current) {
        resetChildStates.current();
      }
    } catch (error) {
      Sentry.captureException(`568 Error in closeAllState: ${error}`);
      console.log(error);
    }
  };

  const handleClose = () => {
    setGridValueSize(0);
    setSelectedBingoType("");
    setBingoInstruction("");
    setBingoNotes("");
    setGrid([]);
    setEditLoteria({});
  };

  const listenToShareData = (classId) => {
    if (!firestore || !classId || !currentUser?.id) {
      return () => {};
    }

    try {
      const collectionRef = collection(firestore, "bingo");
      const q = query(
        collectionRef,
        where("class_id", "==", classId),
        where("status", "==", true)
      );
  
      return onSnapshot(
        q,
        {
          next: async (querySnapshot) => {
            const sessions = [];
            querySnapshot.forEach((doc) => {
              sessions.push({ id: doc.id, ...doc.data() });
            });
            // Add error handling for empty sessions
            if (sessions.length === 0) {
              if(get(currentUser, "role") !== "student") return;
              setDebateResponse({});
              closeAllState();
              return;
            }
            // Process current session
            const currentDate = new Date();
            const filteredData = sessions.find((item) => {
              const createdAt = new Date(item.created_at);
              return createdAt.toDateString() === currentDate.toDateString();
            });
            
            if (filteredData) {
              setDebateResponse(filteredData);
              setWheelSpinResult(filteredData?.wheelSpinResult);
            } else {
              setDebateResponse({});
              closeAllState();
            }
            if (get(currentUser, "role") === "student") {
              if (filteredData) {
                const hasSubmission = await checkStudentHasSubmission(
                  filteredData.id,
                  currentUser.id
                );
                if (!hasSubmission) {
                  // setDebateResponse({});
                  // closeAllState();
                  // return;
                }
                invokeBingoModal();
              } else {
                revokeBingoModal();
              }
            }
          },
          error: (error) => {
            console.error("Session listener error:", error);
            closeAllState();
          }
        }
      );
    } catch (error) {
      Sentry.captureException(`569 Error in listenToShareData: ${error}`);
      console.error("Listen error", error);
      closeAllState();
      return () => {};
    }
  };

  const fitlerGridData = (bingoData, bingoType) => {
    try {
      const flatGrid = bingoData?.length > 0 ? bingoData?.flat() : grid?.flat();
      const filterGrid = (() => {
        switch (bingoType ? bingoType : selectedBingoType) {
          case "VocabImage":
            return (
              flatGrid.filter((cell) => cell?.value && cell?.imageUrl) || []
            );
          case "Image":
            return (
              flatGrid.filter((cell) => cell?.value && cell?.imageUrl) || []
            );
          case "OnlyImage":
            const updatedCells = flatGrid.map(cell => ({
              ...cell,
              value: ''
            }));
            return updatedCells.filter((cell) => cell?.imageUrl) || [];
          default:
            return flatGrid.filter((cell) => cell?.value) || [];
        }
      })();
      return filterGrid;
    } catch (error) {
      Sentry.captureException(`570 Error in fitler Grid Data: ${error}`);
      console.log(error);
    }
  };

  const validateGrid = () => {
    if (!grid) return false;

    for (let index = 0; index < grid.length; index++) {
      const element = grid[index];

      if (selectedBingoType === "Image" || selectedBingoType === "VocabImage") {
        if (element?.imageUrl && !element.value) {
          showSnack(`value is missing for cell ${index + 1}.`, "error");
          return true;
        }

        if (!element?.imageUrl && element?.value) {
          showSnack(`image url is missing for cell ${index + 1}.`, "error");
          return true;
        }
      }
    }

    return false;
  };

  const onDeleteDraft = async () => {
    if (!draftId) return;
    try {
      const docRef = doc(firestore, import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'draft_activity_prod' : 'draft_activity', draftId);
      await deleteDoc(docRef);

      setDraftId(null);
    } catch (error) {
      console.error('error', error);
      Sentry.captureException(error);
    }
  };

  const handleShare = async (
    debateType,
    configuration,
    question,
    grade,
    gradeConfig,
    actionType
  ) => {
    if (validateGrid()) {
      return;
    }

    setShareLoader(true);
    setActionForCreate({ type: actionType, loader: true });
    const fitlerGridTeacherData = fitlerGridData();
    try {
      const key = v4();
      const configurations = {
        grade,
        grade_config: grade ? gradeConfig : {},
        showStudent: false,
        selectedVocabData:
          selectedVocabData?.length > 0 ? selectedVocabData : [],
        ...configuration,
      };

      const bingoType =
        debateType === "VocabWord"
          ? "Word"
          : debateType === "VocabImage"
          ? "Image"
          : debateType === "OnlyImage"
          ? "OnlyImage"
          : debateType;
      const submitData = {
        id: key,
        question,
        criteria: bingoNotes,
        bingo_type: bingoType,
        user_id: get(currentUser, "id", ""),
        class_id: get(currentClass, "id", ""),
        chapter,
        page,
        status: true,
        configurations,
        answer: {},
        bingo_data: fitlerGridTeacherData || [],
        role: get(currentUser, "role", ""),
      };

      const result = await dispatch(handleCreateOneWayBingo(submitData));
      if (get(currentUser, "role", "") === "owe_admin") {
        onDeleteDraft();
      }
      if (get(currentUser, "role", "") === "owe_admin" || actionType === "save") {
        onClose();
      } else {
        if (result) {
          setSelectedGame(result);
          setPlayConfigModal(true);
        }
      }
      dispatch(handleLearningModuleCount({
        chapter: chapter,
        userId: currentUser.id,
        pageId: page,
      }));
    } catch (error) {
      Sentry.captureException(`571 Error in handleShare: ${error}`);
      console.log(error);
    } finally {
      setShareLoader(false);
      setActionForCreate({type: "", loader: false });
    }
  };

  const handleEditLoteria = async (actionType) => {
    if (validateGrid()) {
      return;
    }
    
    setShareLoader(true);
    setActionForCreate({ type: actionType, loader: true });
    const fitlerGridTeacherData = fitlerGridData()

    try {
      const bingoType =
      selectedBingoType === "VocabWord"
        ? "Word"
        : selectedBingoType === "VocabImage"
        ? "Image"
        : selectedBingoType === "OnlyImage"
        ? "OnlyImage"
        : selectedBingoType;
        
      const configurations = {
        ...editLoteria?.configurations,
        grade: isGrade,
        // bingo_type: bingoType,
        grade_config: isGrade ? gradeConfig : {},
        showStudent: false,
        selectedVocabData:
          selectedVocabData?.length > 0 ? selectedVocabData : [],
          bingo_size: gridValueSize,
          bingo_type: selectedBingoType,
      };
      const updatedData = {
        ...editLoteria,
        configurations,
        question: bingoInstruction,
        criteria: bingoNotes,
        bingo_type: bingoType,
        bingo_data: fitlerGridTeacherData || [],
      };
      if (actionType === "save_and_start") {
        // result.status = true;
        // result.created_at = new Date().toISOString();
        // await addDataWithUUIDIfExist(result?.id, result);
        // await createBlankSubmissionsForClassUsers(
        //   result?.id,
        //   classStudentUsers,
        //   result
        // );
        // setAllContentType(true);
        // setBingoGrid(false);
        setSelectedGame(updatedData);
        setPlayConfigModal(true);
      } else {
        const result = await dispatch(handleUpdateOneWayBingo(updatedData));
        setBingoConfig({});
        onClose();
      }
      dispatch(handleLearningModuleCount({
        chapter: chapter,
        userId: currentUser.id,
        pageId: page,
      }));
    } catch (error) {
      Sentry.captureException(`572 Error in handleEditLoteria: ${error}`);
      console.log(error);
    } finally {
      setShareLoader(false);
      setActionForCreate({ type: "", loader: false});
    }
  };

  // Function to add data with UUID if the document with the ID does exist or not
  const addDataWithUUIDIfExist = async (id, data) => {
    const docRef = doc(firestore, "bingo", id);
    const docSnap = await getDoc(docRef);
    try {
      const jsonData = {
        ...data,
        bingo_data: JSON.stringify(data.bingo_data),
        class_id: get(currentClass, "id", ""),
        winner_declared: false,
        winner_id: ''
      };
      if (!docSnap.exists()) {
        await setDoc(docRef, jsonData);
      } else {
        await updateDoc(docRef, jsonData);
      }
    } catch (e) {
      Sentry.captureException(`573 Error in addDataWithUUIDIfExist: ${e}`);
      console.log("Error adding document: ", e);
    }
  };

const createBlankDraft = async (currentUser, currentClass) => {
  const draftId = uuidv4(); // generate unique id
  const docRef = doc(firestore, import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'draft_activity_prod' : 'draft_activity', draftId);

  const draftData = {
    id: draftId,
    question: '',
    configurations: {
      grade: false,
      bingo_size: 0,
      bingo_type: '',
      showStudent: false,
      grade_config: {},
      selectedVocabData: []
    },
    user_id: currentUser?.id || '',
    class_id: currentClass?.id || '',
    chapter: String(chapter),  // 🔒 ensure string
    page: String(page),        // 🔒 ensure string
    bingo_type: '',
    answer: {},
    bingo_data: [],
    created_at: new Date().toISOString(),
    status: true,
    criteria: '',
    role: currentUser?.role || 'teacher'
  };

  try {
    await setDoc(docRef, draftData);
    return draftId;
  } catch (e) {
    console.error("Error creating blank draft:", e);
    return null;
  }
};

  const onPlayGame = async (result) => {
    result.status = true;
    result.created_at = new Date().toISOString();
    const fitlerGridTeacherData = fitlerGridData(result?.bingo_data, result?.configurations?.bingo_type);
    result.bingo_data = fitlerGridTeacherData;
    await addDataWithUUIDIfExist(result?.id, result);
    // Add blank loteria submission for all class users
    await createBlankSubmissionsForClassUsers(
      result?.id,
      classStudentUsers,
      result
    );
    invokeBingoModal();
    setOpenListModal(false);
    setBlogContentType(false);
    setAllContentType(true);
    setBingoGrid(false);
  };

  // Function to add data with UUID if the document with the ID does not exist
  const addDataWithUUIDIfNotExist = async (id, data) => {
    const docRef = doc(firestore, "bingo", id);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      try {
        const jsonData = {
          ...data,
          bingo_data: JSON.stringify(data.bingo_data),
          winner_declared: false,
          winner_id: ''
        };
        await setDoc(docRef, jsonData);
      } catch (e) {
        Sentry.captureException(`574 Error in addDataWithUUIDIfNotExist: ${e}`);
        console.log("Error adding document: ", e);
      }
    }
  };

  // Shuffle function for Bingo only
  const shuffleArray = (array) => {
    let shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ];
    }
    return shuffledArray;
  };

  const getFinalArray = (shuffledItems) => {
    const size = Math.sqrt(shuffledItems.length);
    const groupedArray = [];
    for (let i = 0; i < shuffledItems.length; i += size) {
      groupedArray.push(shuffledItems.slice(i, i + size));
    }
    return groupedArray;
  };

  const createBlankSubmissionsForClassUsers = async (bingoId, classUsers, data) => {
    const batch = writeBatch(firestore);
    
    try {
      const parsedBingoData = Array.isArray(data?.bingo_data)
        ? data.bingo_data
        : JSON.parse(data?.bingo_data || "[]");
      
      const configuration = data?.configurations || {};
      
      const submissionPromises = Array.isArray(classUsers) && classUsers?.map(user => {
        const flatOptions = parsedBingoData.flat();
        const shuffledArr = shuffleArray(
          Array.isArray(flatOptions) && flatOptions?.map(item => ({ ...item, selected: false }))
        );
        
        const shuffledOptions = shuffledArr.slice(
          0,
          configuration?.bingo_size * configuration?.bingo_size
        );
        
        const finalResult = getFinalArray(shuffledOptions);
        const submissionId = v4();
        const generated_session_id = user?.id + bingoId;
        
        const docRef = doc(firestore, "bingo_submission", generated_session_id);
        
        const blankSubmission = {
          submission_id: submissionId,
          bingo_id: bingoId,
          user_id: user.id,
          user_name: `${user.firstName} ${user.lastName}`,
          answer_time: moment().toISOString(),
          answer_text: JSON.stringify(finalResult),
          teacher_response: "",
          student_status: "init",
        };  
        
        batch.set(docRef, blankSubmission);
      });
      
      await batch.commit();
    } catch (error) {
      Sentry.captureException(`575 Error in createBlankSubmissionsForClassUsers: ${error}`);
      console.error("Error creating blank submissions:", error);
    }
  };
  
  useEffect(() => {
    let unsubscribe;

    const initializeListener = async () => {
      if (!closeStudentModal && currentClass?.id && currentUser?.id && firebaseUser) {
        unsubscribe = listenToShareData(currentClass.id);
      }
    };

    initializeListener();

    return () => {
      if (unsubscribe && typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [closeStudentModal, currentClass?.id, currentUser?.id, isWindowActive, firebaseUser]);

  useEffect(() => {
    let session_unsubscribe;
    // if (debateResponse && debateResponse?.id) {
    if (firebaseUser) {
      session_unsubscribe = listenToSubmissionData(
        debateResponse?.id,
        userSubmissionsHandler
      );
    }
    // }
    return () => {
      if (session_unsubscribe && typeof session_unsubscribe === 'function') {
        session_unsubscribe();
      }
    };
  }, [firestore, debateResponse, isWindowActive, firebaseUser]);

  const listenToSubmissionData = (bingoId, onChange) => {
    if (!firestore || !bingoId) {
      return () => {};
    }
    try {
      const collectionRef = collection(firestore, "bingo_submission");
      let q;
      if (currentUser?.role === "teacher") {
        q = query(collectionRef, where("bingo_id", "==", bingoId));
      } else {
        q = query(
          collectionRef,
          where("user_id", "==", currentUser?.id),
          where("bingo_id", "==", bingoId)
        );
      }
      const unsubscribe = onSnapshot(
        q,
        (querySnapshot) => {
          const submission = [];
          querySnapshot.forEach((doc) => {
            submission.push({ id: doc.id, ...doc.data() });
          });
          onChange(submission);
        },
        (error) => {
          if (error.code === 'permission-denied') {
            console.warn("Permission denied for bingo_submission collection. User may not be properly authenticated.");
            return;
          }
          console.log("Error listening to session changes:", error);
        }
      );

      return unsubscribe;
    } catch (error) {
      Sentry.captureException(`576 Error in listenToSubmissionData: ${error}`);
      console.log("listen error", error);
    }
  };

  const userSubmissionsHandler = (data) => {
    if (!Array.isArray(data)) return; // Guard clause for invalid input
    const filterWinner = data.some(
      (item) => item?.teacher_response === "accept"
    );
    const submittedData = data.filter((obj) => obj.student_status === "submitted" && obj?.teacher_response !== "reject" && obj?.teacher_response !== "taking");
    setBingoEndScreen(filterWinner);
    setStudentSubmission(data);
    const myData = data?.filter((obj) => obj.user_id === get(currentUser, "id"));
    if (myData) {
      setMyStudentSubmission(myData);
    }
    setSubmittedSubmission(submittedData);
  };

  // Add this new function to check if student has a submission
  const checkStudentHasSubmission = async (bingoId, userId) => {
    if (!bingoId || !userId) return false;

    try {
      const generated_session_id = userId + bingoId;
      const docRef = doc(firestore, "bingo_submission", generated_session_id);
      const docSnap = await getDoc(docRef);
      return docSnap.exists();
    } catch (error) {
      Sentry.captureException(`577 Error in checkStudentHasSubmission: ${error}`);
      console.error("Error checking student submission:", error);
      return false;
    }
  };


  useEffect(() => {
    if (!debateResponse?.id) return;
  
    const unsubscribe = listenWinnerStatus(debateResponse.id);
  
    return () => {
      if(unsubscribe) unsubscribe();
    };
  }, [debateResponse?.id, currentUser?.id, currentUser?.role, isWindowActive]); // Removed unnecessary dependencies
  
  const listenWinnerStatus = (bingoId) => {
    if (!firestore || !bingoId || !currentUser || currentUser.role !== "student") return () => {};
  
    try {
      const collectionRef = collection(firestore, "bingo_submission");
      const q = query(collectionRef, where("bingo_id", "==", bingoId));
  
      return onSnapshot(
        q,
        (querySnapshot) => {
          const result = querySnapshot.docs.reduce(
            (acc, doc) => {
              if (doc.data().teacher_response === "accept") {
                acc.has_result = true;
                acc.is_me_as_winner = doc.data().user_id === currentUser.id;
              }
              return acc;
            },
            { has_result: false, is_me_as_winner: false }
          );
          setWinnerStatus(result);
        },
        (error) => console.error("Error listening to session changes:", error)
      );
    } catch (error) {
      Sentry.captureException(`578 Error in listenWinnerStatus: ${error}`);
      console.error("Listen error:", error);
      return () => {};
    }
  };

  const handleClickStudentDetail = (i) => {
    setIndex(i);
    setStudentEditClick(false);
    setStudentContentType(true);
  };

  const handleClickCommentDetail = () => {
    setStudentCommentSec(false);
  };

  useEffect(() => {
    if(bingoModal.view){
      setSavedGridState(editLoteria?.bingo_data);
    }
  
  },[editLoteria?.id, bingoModal.view])

  const prevStateHandler = async (value) => {
    const data = await createGridTeacher(
      value?.bingo_size,
      selectedVocabData
    );
  
    if (savedGridState?.length > 0) {
      const updatedGrid = data.map((cell, index) => {
        if (index < savedGridState.length) {
          return {
            ...cell,
            value: savedGridState[index]?.value || "",
            imageUrl: savedGridState[index]?.imageUrl || "",
            isCustom: false
          };
        }
        return cell;
      });
      
      // Add remaining savedGridState cells that have non-empty values
      const remainingFilledCells = savedGridState
        .slice(data.length)
        .map(cell => ({
          ...cell,
          isCustom: false
        })).filter(cell => cell?.value &&  cell?.value !== "" || cell?.imageUrl &&  cell?.imageUrl !== "");
     
      // Combine both arrays to form the final grid
      const finalGrid = updatedGrid.concat(remainingFilledCells);
      
      return finalGrid;
    } else {
      return data;
    }
  };
  

  const handleBingoConfig = async (
    value,
    instruction,
    notes,
    grade,
    gradingConfig
  ) => {
    try {
      if (value?.bingo_type === "OnlyImage" || value?.bingo_type === "Image" || value?.bingo_type === "VocabImage") {
        dispatch(handleListOneGameGallery())
        dispatch(handleListOneGameCategory("pictures_categories"))
      }
      if (
        grade &&
        !gradingConfig?.grade_type?.type &&
        !gradingConfig?.ungraded
      ) {
        return showSnack("Please Choose a grade system!", "error");
      }

      if (grid?.length > 0 && savedGridState?.length > 0) {
        const updatedGrid = await prevStateHandler(value);

        if (selectedVocabData?.length > 0) {
          const existingValuesSet = new Set(updatedGrid.map((item) => item.value));
          const newVocabItems = [];
          let i = 0;
          selectedVocabData.forEach((ele) => {
            if (!existingValuesSet.has(ele)) {
              newVocabItems.push({
                ...ele,
                isCustom: false,
                cellSize: 3,
                value: ele,
                backgroundColor: COLORS[i] ? COLORS[i++] : generateRandomLightColor(),
              });
            }
          });
          
          setGrid([...newVocabItems, ...updatedGrid]);
        } else {
          setGrid(updatedGrid);
        }
      }else{
        setGrid(createGridTeacher(value?.bingo_size, selectedVocabData));
      }

      if (
        value?.bingo_type !== selectedBingoType ||
        value?.bingo_size !== gridValueSize
      ) {
        setSelectedBingoType(value?.bingo_type);
        setGridValueSize(value?.bingo_size);
        setBingoConfig(value);
        setIsGrade(grade);
        setGradeConfig(gradingConfig);
      }
      if (editLoteria && Object.keys(editLoteria).length > 0) {
        setBingoConfig(value);
        setIsGrade(grade);
        setGradeConfig(gradingConfig);
      }
      if (instruction !== bingoInstruction) {
        setBingoInstruction(instruction);
      }
      if (notes !== bingoNotes) {
        setBingoNotes(notes);
      }
      setBingoGrid(true);
      setBlogContentType(false);
    } catch (error) {
      Sentry.captureException(`579 Error in handleBingoConfig: ${error}`);
      console.log(error);
    }
  };

  useEffect(() => {
    if (bingoModal.view === true) {
      document.body.style.setProperty("overflow", "hidden", "important");
    } else {
      document.body.style.setProperty("overflow", "", "important");
    }
  }, [bingoModal]);

  const gridBackOpenConfigBingo = () => {
    if(savedGridState?.length > 0){
      const updatedSavedGrid = [...savedGridState];
      grid.forEach((item, index) => {
        updatedSavedGrid[index] = item;
        updatedSavedGrid[index].isCustom = false;
      });
      setSavedGridState(updatedSavedGrid);
    }else{
      setSavedGridState([...grid]);
    }
    setBingoGrid(false);
    setOpenTeacherModal(true);
    setBlogContentType(true);
  };

  const BackHandler = (section) => {
    switch (section) {
      case "gridSection":
        gridBackOpenConfigBingo();
      default:
        return "";
    }
  };

  useEffect(() => {
    const classNames = ["overflow-hidden"];

    if (bingoModal.view || bingoModals) {
      document.body.classList.add(...classNames);
    } else {
      document.body.classList.remove(...classNames);
    }
    return () => {
      document.body.classList.remove(...classNames);
    };
  }, [bingoModal.view, bingoModals]);

  useEffect(() => {
    if (bingoModals) {
      if (
        get(currentUser, "role") === "student" &&
        Object.keys(debateResponse).length === 0
      ) {
        showSnack("No active Lotería", "error");
      } else {
        if (
          Object.keys(debateResponse).length === 0 &&
          get(currentUser, "role") !== "student"
        ) {
          setOpenListModal(true);
        } else {
          if (debateResponse?.winner_declared) {
            handleOpenDebateModal(debateResponse);
          }
          invokeBingoModal();
        }
      }
      setBingoModals(false);
    }
  }, [bingoModals])

  const onBingoEdit = (bingoData = {}) => {
    try {
      const { configurations = {}, criteria, question, bingo_data } = bingoData;
      const {
        grade_config = {},
        grade,
        bingo_size,
        bingo_type,
        selectedVocabData
      } = configurations;
      if (selectedVocabData) {
        setSelectedVocabData(selectedVocabData);
      }
      setEditLoteria(bingoData);
      setBingoNotes(criteria);
      setBingoInstruction(question);
      setGridValueSize(bingo_size);
      setSelectedBingoType(bingo_type);
      setGrid(bingo_data);
      setGardeEnable(grade);
      if (grade) {
        const { grade_category, grade_type, ungraded } = grade_config;
        setGameGradeCategory(grade_category);
        setGameGradeType(grade_type);
        setGameUngraded(ungraded);
      }
    } catch (error) {
      Sentry.captureException(`580 Error in onBingoEdit: ${error}`);
      console.log(error);
    }
  };

  const updateCollectionForWheel = async (data = null) => {
    if (!data) {
      return;
    }
    setSubmitLoader(true);
    const updateStudentData = {
      wheelSpinResult: data ? data : wheelSpinResult,
    };

    const docRef = doc(firestore, "bingo", debateResponse?.id);
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, updateStudentData);
      }
    } catch (e) {
      Sentry.captureException(`581 Error in updateCollectionForWheel: ${e}`);
      console.log("Error adding document: ", e);
    } finally {
      setSubmitLoader(false);
    }
  };

  // Create a memoized function to update winner status
const updateWinnerStatus = useCallback((newStatus) => {
  setWinnerStatus(newStatus);
  winnerStatusRef.current = newStatus;
}, []);

// When opening the DebateModalWrapper
const handleOpenDebateModal = useCallback((debateResponses) => {
  const is_me_as_winner = debateResponses?.winner_id === currentUser?.id;

  const newWinnerStatus = {
    has_result: debateResponses?.winner_declared,
    is_me_as_winner
  };
  updateWinnerStatus(newWinnerStatus);
}, [updateWinnerStatus]);

const updateCollectionForReject = async (data = null) => {
  if (!firestore || !data) {
    return;
  }
  setSubmitLoader(true);

  const updateStudentData = {
    teacher_response: 'taking',
  };

  const q = query(
    collection(firestore, "bingo_submission"),
    where("user_id", "==", data) // Filter by user_id
  );

  try {
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      querySnapshot.forEach(async (docSnap) => {
        await updateDoc(docSnap.ref, updateStudentData);
      });
      }
    } catch (e) {
      Sentry.captureException(`582 Error in updateCollectionForReject: ${e}`);
    console.log("Error updating document: ", e);
  } finally {
    setSubmitLoader(false);
  }
};


  return (
    <SentryWrap>
      <div>
        <Snackbar
                open={snack.open}
                autoHideDuration={3000}
                onClose={() => setSnack({ ...snack, open: false })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setSnack({ ...snack, open: false })}
                  severity={snack.severity}
                  sx={{ width: "100%" }}
                >
                  {snack.message}
                </Alert>
              </Snackbar>

        <DebateModalWrapper
          style={{display: !showIcon &&  "none"}}
          role={get(currentUser, "role")}
          onClick={() => {
            if(checkPopUpAtOnce()) return;
            if(handleForDistrictAdmin()) return;
            if (
              get(currentUser, "role") === "student" &&
              Object.keys(debateResponse).length === 0
            ) {
              showSnack("No active lotería", "error");
            } else {
              if (
                Object.keys(debateResponse).length === 0 &&
                get(currentUser, "role") !== "student"
              ) {
                setOpenListModal(true);
              } else {
                if (debateResponse?.winner_declared) {
                  handleOpenDebateModal(debateResponse);
                }
                invokeBingoModal();
              }
              dispatch(handleListClassUsers(get(currentClass, "id")))
              dispatch(handleLearningModuleCount({
                pageId: page,
                chapter: chapter,
                userId: get(currentUser, "id"),
              }))
              updatePopUpAtOnce(true);
            }
          }}
          className='addOneImg adminImgUpr'
        > 
        
          {get(currentUser, "role") === "student" ? (
            <div>
              <Badge
                  overlap="rectangular"
                  badgeContent={pageLearningModuleCount?.bingo_status ? "✓" : undefined}
                  color="success"
                  variant="standard"
                >
              <img
                className={`addOneImg ${type === "bottom"}`}
                src={LoteriaGameIcon}
                alt="Loteria"
                title="Loteria"
              />
              </Badge>
            </div>
          ) : (
            <div className='adminLoteriaImg'>
              <Badge
                  overlap="rectangular"
                  badgeContent={pageLearningModuleCount?.bingo_status ? "✓" : undefined}
                  color="success"
                  variant="standard"
                  sx={{width: '100%'}}
                >
              <img
                className={`${type === "bottom"}`}
                src={LoteriaGameIcon}
                alt="Loteria"
                title="Loteria"
              />
              </Badge>
            </div>
          )}
          

        </DebateModalWrapper>
        
        <OneBingoModal
          chapter={chapter}
          page={page}
          currentUser={currentUser}
          currentClass={currentClass}
          aiModal={openListModal}
          setAiModal={setOpenListModal}
          setDraftId={setDraftId}
          showModalBingo={async () => {
            if (get(currentUser, "role", "") === "owe_admin") {
              const newDraftId = await createBlankDraft(currentUser, currentClass);
              if (newDraftId) setDraftId(newDraftId);
            }
            await closeAllState();
            invokeBingoModal();
          }}
          onPlayGame={async (e) => await onPlayGame(e)}
          onGameEdit={(e) => {
            invokeBingoModal();
            onBingoEdit(e);
          }}
          newMaskId={newMaskId}
          pageLearningModuleCount={pageLearningModuleCount}
        />
        {get(currentUser, "role") === "student" && (
          <StudentConfirm
            bingoResponse={debateResponse}
            studentSubmission={myStudentSubmission}
            currentUser={currentUser}
          />
        )}
        <Modal
          wrapClassName="bingoModalWrap"
          open={bingoModal.view}
          onCancel={onClose}
          className="ideaOneModel debateOneModel bingoModal"
          maskClosable={false}
          zIndex={from === 'admin_resource' ? 9999999 : 999}
          getContainer={from === 'admin_resource' ? false : undefined}
          >
          {get(currentUser, "role") === "student" && debateResponse && (
            <BingoStudentContent
              showSnack={showSnack}
              currentUser={currentUser}
              bingoResponse={debateResponse}
              submitLoader={submitLoader}
              studentSubmission={myStudentSubmission}
              onStudentAnswer={(value) => {
                createNewCollection(value);
              }}
              handleChangeStatus={async (value) => {
                await updateCollectionForReject(value);
              }}
              updateRealTimeClick={async (value) => {
                await updateRealTimeClick(value, debateResponse?.id, get(currentUser, 'id', ''))
              }}
              bingoEndScreen={bingoEndScreen}
              winnerStatus={winnerStatus}
            />
          )}

          {studentEditClick && allContentType && debateResponse?.id && (
            <>
              <BingoStudentsResult
                handleClickStudentDetail={(i) => handleClickStudentDetail(i)}
                debateInfo={debateResponse}
                currentUser={currentUser}
                studentSubmission={submittedSubmission}
                setWheelSpinResult={setWheelSpinResult}
                wheelSpinResult={wheelSpinResult}
                updateCollectionForWheel={updateCollectionForWheel}
                showNames={showNames}
                setShowNames={setShowNames}
                debateResponse={debateResponse}
                themeSongProps={{ initialSongIndex: selectedThemeSongIndex }}
                disableAutoSpin={deleteModal || endLoader}
              />
            </>
          )}

          {studentContentType && (
            <BingoStudentDetail
              bingoEndScreen={bingoEndScreen}
              debateInfo={debateResponse}
              indexs={indexs}
              studentSubmission={submittedSubmission}
              resultLoader={resultLoader}
              handleClickAnswerDetail={() => {
                setStudentEditClick(true);
                setStudentContentType(false);
              }}
              handleEvaluation={async (id, result,) => {
                if (!id || !id.submission_id) {
                  console.error("Invalid submission data: id or submission_id is undefined");
                  showSnack("Invalid submission data: id or submission_id is undefined", "error");
                  setResultLoader(false);
                  return;
                }
                setResultLoader(result);
                await updateLoteriaResult(id?.submission_id, result);
                if (id?.user_id) {
                  await updateTeacherWinner(debateResponse?.id, result, id?.user_id);
                }
                setResultLoader(false);
              }}
              wheelSpinResult={wheelSpinResult}
              showNames={showNames}
              setShowNames={setShowNames}
              showSnack={showSnack}
              themeSongProps={{ initialSongIndex: selectedThemeSongIndex }}
            />
          )}
          {studentCommentSec &&
            blogContentType &&
            get(currentUser, "role") !== "student" && (
              <BingoCreateSection
                draftId={draftId}
                shareLoader={shareLoader}
                handleConfigShare={(value, question, notes, grade, gradingConfig) => {
                  handleBingoConfig(value, question, notes, grade, gradingConfig);
                }}
                onAiError={() => {
                  showSnack("Please try with other question.", "error");
                }}
                onReset={(resetFn) => {
                  resetChildStates.current = resetFn;
                }}
                setOpenTeacherModal={setOpenTeacherModal}
                selectedBingoType={selectedBingoType || ""}
                gridValueSize={gridValueSize}
                bingoInstruction={bingoInstruction}
                bingoNotes={bingoNotes}
                vocabData={getBooksVocab}
                selectedVocabData={selectedVocabData}
                setSelectedVocabData={setSelectedVocabData}
                editLoteria={editLoteria}
                setGardeEnable={setGardeEnable}
                gradeEnable={gradeEnable}
                setGameGradeCategory={setGameGradeCategory}
                game_grade_category={game_grade_category}
                game_grade_type={game_grade_type}
                setGameGradeType={setGameGradeType}
                game_ungraded={game_ungraded}
                setGameUngraded={setGameUngraded}
                from_where={from_where}
              />
            )}
          {playConfigModal && (
          <GradeModal
            playConfigModal={playConfigModal}
            setPlayConfigModal={setPlayConfigModal}
            currentUser={currentUser}
            currentClass={currentClass}
            onPlayGame={async (result) => {
              if (editLoteria?.id) {
                  result.status = true;
                  result.created_at = new Date().toISOString();
                  await addDataWithUUIDIfExist(result?.id, result);
                  await createBlankSubmissionsForClassUsers(
                    result?.id,
                    classStudentUsers,
                    result
                  );
                  setAllContentType(true);
                  setBingoGrid(false);
              } else {
                  await addDataWithUUIDIfNotExist(result.id, result);
                  // Add blank loteria submission for all class users
                  await createBlankSubmissionsForClassUsers(
                    result.id,
                    classStudentUsers,
                    result
                  );
                  setBingoGrid(false);
                  setAllContentType(true);
              }
            }}
            selectedGame={selectedGame}
            setSelectedGame={setSelectedGame}
          />
          )}
          {bingoGrid && (
            <BingoGridSection
              grid={grid}
              shareLoader={shareLoader}
              selectedType={selectedBingoType}
              onGridChange={(updatedGrid) => {
                setGrid(updatedGrid);
              }}
              setGrid={setGrid}
              handleClickHideSec={debounce((actionType) => {
                if (editLoteria?.id && !draftId) {
                  handleEditLoteria(actionType);
                } else {
                  handleShare(
                    selectedBingoType,
                    bingoConfig,
                    bingoInstruction,
                    isGrade,
                    gradeConfig,
                    actionType
                  );
                }
              }, 500)}
              backHandler={BackHandler}
              bingoSize={gridValueSize}
              currentUser={currentUser}
              actionForCreate={actionForCreate}
              showSnack={showSnack}
            />
          )}
        </Modal>
        <DeleteModal
          message={`Are you sure you want to end this Lotería?`}
          deleteToggle={deleteModal}
          setDeleteToggle={setDeleteModal}
          loading={endLoader}
          onDelete={updateStatus}
          buttonTitle={"Yes"}
        />
      </div>
    </SentryWrap>
  );
};

export default BingoModal;
